import script from "./w-Header.vue?vue&type=script&setup=true&lang=js"
export * from "./w-Header.vue?vue&type=script&setup=true&lang=js"

import "./w-Header.vue?vue&type=style&index=0&id=f2d9692a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2d9692a"]])

export default __exports__